import type { AppAbilityRule } from '@shared/types/ability';

function includesRuleValue(value: string | string[], expected: string): boolean {
  return Array.isArray(value) ? value.includes(expected) : value === expected;
}

export function hasExplicitPermissionRule(
  rules: readonly AppAbilityRule[] | null | undefined,
  action: string,
  subject: string
): boolean {
  return (
    rules?.some(
      (rule) =>
        rule.inverted !== true &&
        includesRuleValue(rule.action, action) &&
        includesRuleValue(rule.subject, subject)
    ) ?? false
  );
}
